/** Safely writes a value to localStorage, stripping inline script tags. */
export const safeStorage = {
  setItem: (key: string, value: string): void =>
    localStorage.setItem(key, value?.replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, '')),
};
